import {
  safeSessionStorageGetItem,
  safeSessionStorageSetItem,
} from '../storage/storage.utils';

export function utmSourceFromUrl(hrefOrUndefined?: string): string | undefined {
  const href = hrefOrUndefined ?? window.location.href;

  const url = new URL(href);
  const utmSource: string | null =
    url.searchParams.get('utm_source') ??
    safeSessionStorageGetItem('UTM_SOURCE');

  if (!utmSource) {
    return;
  }

  safeSessionStorageSetItem('UTM_SOURCE', utmSource);
  return utmSource;
}

export function utmMediumFromUrl(hrefOrUndefined?: string): string | undefined {
  const href = hrefOrUndefined ?? window.location.href;

  const url = new URL(href);
  const utmMedium: string | null =
    url.searchParams.get('utm_medium') ??
    safeSessionStorageGetItem('UTM_MEDIUM');

  if (!utmMedium) {
    return;
  }

  safeSessionStorageSetItem('UTM_MEDIUM', utmMedium);
  return utmMedium;
}

export function utmCampaignFromUrl(
  hrefOrUndefined?: string,
): string | undefined {
  const href = hrefOrUndefined ?? window.location.href;

  const url = new URL(href);
  const utmCampaign: string | null =
    url.searchParams.get('utm_campaign') ??
    safeSessionStorageGetItem('UTM_CAMPAIGN');

  if (!utmCampaign) {
    return;
  }

  safeSessionStorageSetItem('UTM_CAMPAIGN', utmCampaign);
  return utmCampaign;
}
